import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import withErrorHandler from '../../utils/withErrorHandler';
import IconFavoriteStar from './icon-favorite-star.svg';
import IconFavoriteStarHover from './icon-favorite-star-hover.svg';
import IconFavoriteStarActive from './icon-favorite-star-active.svg';
import { handleFavorite as handleFavoriteAction } from '../../actions/actionsSet/assetService';

const ImgStar = styled.div`
  width: 18px;
  height: 18px;
  cursor: pointer;
  background: url(${IconFavoriteStar}) no-repeat;
  background-size: 100% 100%;
  &:hover {
    background: url(${IconFavoriteStarHover}) no-repeat;
    background-size: 100% 100%;
  }

  ${({ active }) => {
    if (active) return `background: url(${IconFavoriteStarActive}) no-repeat;background-size: 100% 100%;`;
    return '#';
  }}
`

const mapDispatchToProps = {
  handleFavorite: handleFavoriteAction,
};

export default
@connect(null, mapDispatchToProps)
@withErrorHandler
class FavoriteStar extends PureComponent {
  static propTypes = {
    symbol: PropTypes.string.isRequired,
    active: PropTypes.bool,
    handleFavorite: PropTypes.func.isRequired,
    style: PropTypes.object,
    handleForceUpdate: PropTypes.func,
  };

  static defaultProps = {
    style: {},
    active: false,
  };

  _favoriteSetter = ev => {
    ev.stopPropagation();
    // ev.preventDefault();

    const { symbol, handleFavorite, handleForceUpdate } = this.props;
    handleFavorite && handleFavorite(symbol);
    handleForceUpdate && handleForceUpdate();
  };

  render() {
    const { style, active } = this.props;

    return  <ImgStar style={{marginRight: 8}} active={active} onClick={this._favoriteSetter}/>
     
  }
}
